/** Resolve HTML body for outbox drawer preview — never prefer body_plain over body_html. */
export function resolveOutboxBodyHtml(draft) {
  if (!draft || typeof draft !== 'object') return '';

  const candidates = [
    draft.body_html,
    draft.bodyHtml,
    draft.html,
    draft.message?.body_html,
    draft.message?.bodyHtml,
    draft.compose?.body_html,
    draft.compose?.bodyHtml,
  ];

  for (const value of candidates) {
    if (value != null && String(value).trim() !== '') {
      return String(value);
    }
  }

  const body = draft.body;
  if (body != null && String(body).trim() !== '' && /<[a-z][\s\S]*>/i.test(String(body))) {
    return String(body);
  }

  return '';
}

export function outboxBodyHtmlNeedsFetch(draft) {
  if (!draft) return false;
  const html = resolveOutboxBodyHtml(draft);
  if (!html) return true;
  if (/<a\s[\s\S]*?href=/i.test(html)) return false;
  const plain = draft.body_plain ?? draft.bodyPlain;
  if (plain && String(plain).trim()) return true;
  const body = draft.body;
  if (body && String(body).trim() && !/<[a-z]/i.test(String(body))) return true;
  return false;
}
